import React from "react";
import api from '../../api/client';
import { Box, Button, Typography } from "@material-ui/core";
import WarningIcon from '@material-ui/icons/Warning';
import { useRecoilState } from "recoil";
import { usersState } from "../../pages/admin/atoms";
import { toast } from "../../api/toast";

function DeleteUser({ id, setOpenDeleteUser }) {
  const [users, setUsers] = useRecoilState(usersState);
  const user = users.find(u => u.id === id) || null;

  const onDelete = async () => {
    try {
      await api.delete(`users/admin/users/${id}/`);
      setUsers(users.filter(u => u.id !== id));
      setOpenDeleteUser(-1);
    } catch (e) {
      toast((e && e.response && e.response.data && e.response.data.detail) || 'خطا در حذف کاربر');
    }
  };

  return (
    <div style={{ direction: "rtl" }}>
      <Box display="flex" alignItems="flex-start" gap={1.5} style={{ background: '#fff3f3', border: '1px solid #ffcdd2', borderRadius: 10, padding: 14 }}>
        <WarningIcon style={{ color: '#c62828', fontSize: 30, flexShrink: 0 }} />
        <Box>
          <Typography style={{ fontWeight: 800, color: '#c62828' }}>
            حذف کاربر {user ? user.username : id}
          </Typography>
          <Typography variant="body2" style={{ marginTop: 6, lineHeight: 2, color: '#555' }}>
            حساب کاربری این شخص از سامانه حذف و دسترسی او قطع می‌شود. این عملیات برگشت‌پذیر نیست.
          </Typography>
        </Box>
      </Box>
      <Box mt={2} display="flex" style={{ marginTop: 16 }}>
        <Button
          color="secondary"
          variant="contained"
          style={{ backgroundColor: '#c62828', color: '#fff', fontWeight: 'bold' }}
          onClick={onDelete}
        >
          بله، حذف شود
        </Button>
        <Button variant="outlined" style={{ marginInlineStart: 8 }} onClick={() => setOpenDeleteUser(-1)}>
          انصراف
        </Button>
      </Box>
    </div>
  );
}

export default DeleteUser;
